/* eslint-disable react/forbid-prop-types */
import { noop } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import { LocaleService } from '@sm360/widget-commons-core-services';

import PurchaseMethodsModel from 'commons-vehicle/PurchaseMethods/models/PurchaseMethodsModel.js';
import VehicleTitle from 'commons-vehicle/Vehicle/components/Overview/VehicleTitle/VehicleTitle.jsx';
import TileTag from 'commons-vehicle/Vehicle/components/TileTag/TileTag.jsx';
import PaymentDetail from 'commons-vehicle/Vehicle/components/Payment/PaymentDetail/PaymentDetail.jsx';
import PaymentDetailV2 from 'commons-vehicle/Vehicle/components/PaymentV2/PaymentDetail/PaymentDetail.jsx';

import 'commons-vehicle/Vehicle/components/Overview/Overview.scss';

const VehicleSummary = ({
    isUsed,
    optionalButton,
    packageName,
    purchaseMethods,
    taxCodes,
    taxesDisclaimer,
    title,
    vehicleStockNo,
    isReserved,
    isCustomTag,
    customTagContent,
    vehicleVinNo,
    optionalDemoTag,
    includedDealerIncentives,
    tagline,
    config,
    displayCreditRate,
    displayFactoryOrder,
    isPageTitle,
}) => {
    return (
        <div className="vehicle-overview">
            <TileTag
                shouldRender={isReserved}
                icon="icon-lock"
                background="#F5273F"
                color="#fff"
                text={LocaleService.t('VEHICLE_STATUS.RESERVED')}
            />
            <TileTag
                shouldRender={isCustomTag && customTagContent}
                background="#f2bf24"
                color="#fff"
                text={customTagContent}
            />
            {optionalDemoTag && <div className="demo-tag">{LocaleService.t('VEHICLE_STATUS.DEMO_TAG')}</div>}
            {displayFactoryOrder && (
                <div className="factory-order-label">
                    <span>{LocaleService.t('VEHICLE_STATUS.FACTORY_ORDER')}</span>
                </div>
            )}
            <VehicleTitle
                title={title}
                packageName={packageName}
                vehicleStockNo={vehicleStockNo}
                vehicleVinNo={vehicleVinNo}
                tagline={tagline}
                isPageTitle={isPageTitle}
            />
            {purchaseMethods instanceof PurchaseMethodsModel ? (
                <PaymentDetailV2
                    purchaseMethods={purchaseMethods}
                    isUsed={isUsed}
                    taxCodes={taxCodes}
                    taxesDisclaimer={taxesDisclaimer}
                    includedDealerIncentives={includedDealerIncentives}
                    config={config}
                    displayCreditRate={displayCreditRate}
                />
            ) : (
                <PaymentDetail
                    purchaseMethods={purchaseMethods}
                    isUsed={isUsed}
                    taxCodes={taxCodes}
                    taxesDisclaimer={taxesDisclaimer}
                    includedDealerIncentives={includedDealerIncentives}
                    config={config}
                    displayCreditRate={displayCreditRate}
                />
            )}
            {optionalButton}
        </div>
    );
};

VehicleSummary.defaultProps = {
    isUsed: false,
    isReserved: false,
    packageName: '',
    vehicleStockNo: '',
    optionalButton: noop,
    vehicleVinNo: '',
    optionalDemoTag: false,
    includedDealerIncentives: false,
    taxesDisclaimer: '',
    purchaseMethods: new PurchaseMethodsModel(),
    isCustomTag: false,
    customTagContent: '',
    tagline: null,
    config: {},
    displayCreditRate: false,
    displayFactoryOrder: false,
    isPageTitle: false,
};

VehicleSummary.propTypes = {
    isUsed: PropTypes.bool,
    optionalButton: PropTypes.func,
    packageName: PropTypes.string,
    vehicleStockNo: PropTypes.string,
    purchaseMethods: PropTypes.shape({
        cashPurchase: PropTypes.object.isRequired,
        financing: PropTypes.object.isRequired,
    }),
    taxCodes: PropTypes.string.isRequired,
    taxesDisclaimer: PropTypes.string,
    title: PropTypes.string.isRequired,
    isReserved: PropTypes.bool,
    vehicleVinNo: PropTypes.string,
    optionalDemoTag: PropTypes.bool,
    includedDealerIncentives: PropTypes.bool,
    isCustomTag: PropTypes.bool,
    customTagContent: PropTypes.string,
    tagline: PropTypes.string,
    config: PropTypes.object.isRequired,
    displayCreditRate: false,
    displayFactoryOrder: false,
    isPageTitle: PropTypes.bool,
};

VehicleSummary.displayName = 'VehicleSummary';

export default VehicleSummary;
